import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { needsConfirming } from '../utils/appointment-confirmation';

/**
 * "Not yet confirmed": the calendar and the upcoming list show only bookings still to confirm, for the calls
 * before the day (tasks/appointment-confirmed.md). Shared so both views agree; not remembered between visits,
 * so nobody comes back to a calendar that quietly hides confirmed bookings.
 */
@Injectable({
  providedIn: 'root',
})
export class CalendarConfirmFilterService {
  private readonly unconfirmedOnlySubject = new BehaviorSubject<boolean>(false);

  readonly unconfirmedOnly$: Observable<boolean> = this.unconfirmedOnlySubject.asObservable();

  get unconfirmedOnly(): boolean {
    return this.unconfirmedOnlySubject.getValue();
  }

  setUnconfirmedOnly(on: boolean): void {
    if (on !== this.unconfirmedOnly) this.unconfirmedOnlySubject.next(on);
  }

  applyAppointmentFilter<T>(rows: T[] | null | undefined, on: boolean = this.unconfirmedOnly): T[] {
    return on ? (rows || []).filter(needsConfirming) : (rows || []);
  }
}
